/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
import { useState, useEffect } from 'react';
import createActivityDetector from 'activity-detector';
import userServices from '../../../../redux/services/userServices';

const useTimeCounter = (userId, unitId) => {
  const [counter, setCounter] = useState(1);
  const [isIdle, setIsIdle] = useState(false);

  /*
  useEffect(() => {
    const activityDetector = createActivityDetector({
      timeToIdle: 1000 * 60 * 60, // 1 hour
      activityEvents: ['click', 'mousemove', 'keydown', 'DOMMouseScroll', 'mousewheel', 'mousedown', 'touchstart', 'touchmove', 'focus'],
      inactivityEvents: [],
    });
    activityDetector.on('idle', () => setIsIdle(true));
    activityDetector.on('active', () => setIsIdle(false));
    return () => activityDetector.stop();
  }, [isIdle, unitId]);
  */

  useEffect(() => {
    if ((counter % 10 === 0) && (unitId)) {
      userServices.setUnitTracker(userId, unitId, 12);
      setCounter(1);
    }
  }, [(counter % 10 === 0)]);

  // remove isIdle VVV
  useEffect(() => {
    const timer = setInterval(() => !isIdle && setCounter(counter + 1), 1000);
    return () => clearInterval(timer);
  }, [counter, isIdle]);

  return isIdle;
};

export default useTimeCounter;
